const Join = () => {
  return (
    <section id="discord">
      <div className="container">
        <h2 data-aos="fade">Join the Community</h2>
        <p>
        Check out our Discord, Twitter  and Telegram platforms We have an amazing community full of interactive and creative people, it is based on mutual respect and understanding between the members, all types of offensive content or actions are forbidden. We support friendship, creativity and Aesthetic ideas.
        </p>
        <div>

          {/* <a data-aos="zoom-in" data-aos-duration="1500" href="" target="_blank" rel="noopener noreferrer" className="cta">
            Join our Discord
          </a> */}
        </div>
        <div className="meka" data-aos="fade-up" data-aos-duration="2000" data-aos-offset={420}></div>
      </div>
    </section>
  );
};

export default Join;
